import axios from './configObra/config-obra';

const defaultRoute = '/filial';

export default {
    list: () => axios.get(`${defaultRoute}`),
    vincUser: (filialId, UserId) => axios.patch(`${defaultRoute}/vincularuserfilial/${filialId}`, {
        iduser: UserId
      }),
    create: (empresa) => axios.post(defaultRoute, empresa),
    update: (id, empresa) => axios.patch(`${defaultRoute}/${id}`, empresa),
    remove: (id) => axios.delete(`${defaultRoute}/${id}`),
    listByEmpresa: (id) => axios.get(`${defaultRoute}/empresa/${id}`),
}
